<template>
  <div v-if="body_show" class="bodys">
    <!-- 海报显示 -->
    <h2 class="report-title text-center">{{title}}</h2>
    <div v-if="report.length" class="report_main">
      <div v-for="(item,index) in report" :key="index">
        <img :src="item" class="report_img" @click="img_preview(index)" />
        <h5>*长按卡片可保存</h5>
      </div>
    </div>
    <div v-else class="pb50 text-center">
      暂未提交报告
    </div>
    <!-- 标签 -->
    <div class="pd_auto">
      <div class="tag_box">
        <div @click="toggleTag(item, index)" v-for="(item, index) in label" :key="item.id" :class="[item.support ? 'active' : '' , 'tag_btn']">{{ item.label_title }} {{ item.num }}</div>
      </div>
      <div class="pr">
        <div class="round text-center">
          <img @click="tagModul = true" src="@a/add.png" alt="" />
          <p class="add-text">添加标签</p>
        </div>
      </div>
    </div>
    <div class="bg-board"></div>
    <!-- 留言 -->
    <div class="message">
      <div>
        <!-- item -->
        <div v-for="(item, index) in reply" :key="item.id" :class="[index === (reply.length-1) ? 'no-border' : '', 'msg-item']">
          <!-- 评价头部 -->
          <div class="msg-head clearfix pr">
            <div class="ico pull-left">
              <div class="ico-img">
                <img :src="item.headimgurl" alt="" />
              </div>
            </div>
            <div class="msg-user pull-right pr">
              <h4>{{ item.name }}</h4>
              <p class="msg-date pa">{{ item.ctime }}</p>
            </div>
            <!-- 点赞 -->
            <div class="favor pa">
              <span :class=" item.praise ? 'active' : '' ">{{ item.praise_num }}</span>
              <img @click="setPraise(item.id, index, 'add', true)" v-show="!item.praise" src="@a/hand_gray.png" alt="" />
              <img @click="setPraise(item.id, index, 'cancel', false)" v-show="item.praise" src="@a/hand_red.png" alt="" />
            </div>
          </div>
          <!-- 评价内容 -->
          <div ref="msg_ref" @click="toggleReply(item, true)" :class="[item.textOverFlow ? 'msg-over' : '', 'msg-con text-break msg-font']">
            {{ item.reply }}
          </div>
          <!-- 提示信息 -->
          <div class="msg-menu">
            <p v-if="!index">（点击上面文字可以回复此条评论）</p>
            <div v-if="item.surplus">
              <span v-show="!item.textOverFlow" @click="ofShowContent(index, true)" class="btn color-blue">收起</span>
              <span v-show="item.textOverFlow" @click="ofShowContent(index, false)" class="btn color-blue">全文</span>
            </div>
          </div>
          <!-- 子回复 -->
          <div class="child-reply msg-font">
            <div v-for="(item2, index2) in item.list" :key="item2.id" :class="[index2 === (item.list.length-1) ? 'no-border' : '', 'child-item']">
              <div class="ch-item-con pr">
                <div class="ch-con">
                  <div class="ch-key-title">
                    <h4 class="color-blue text-bold">{{ item2.name }}</h4>
                    <p class="text-break">回复 <span class="color-blue text-bold">{{ item2.rname }} : </span><span>{{ item2.reply }}</span></p>
                  </div>
                </div>
                <div class="ch-w-ico pa">
                  <img :src="item2.rheadimgurl" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- item -->
      </div>
    </div>
    <div style="max-width: 10rem;margin: 0 auto;" class="fixed-reply">
      <div :class="[commentShow ? 'block' : 'none', 'pr']">
        <div>
          <van-cell-group>
            <van-field
              class="inps"
              :clearable="true"
              v-model="replyContent"
              type="textarea"
              ref="RC"
              autofocus
              :placeholder="`回复${replyName}`"
              rows="1"
              autosize
              @blur="toggleReply({}, false)"
            />
          </van-cell-group>
        </div>
      </div>
      <img class="save-btn pa" @click="submitHandle"  src="@a/fly.png" alt="">
    </div>
    <!-- pop -->
    <van-dialog
      v-model="tagModul"
      show-cancel-button
      @confirm="addTag"
    >
      <div class="tag-modul">
        <h3 class="text-center">添加标签</h3>
        <div class="clearfix form-pd">
          <div>
            <input type="text" v-model="newTagVal" placeholder="请输入标签名称" />
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
  import { TaskShow, PraiseSub, LableAdd, LableSub, ReplySub } from "@/api/course";
  import { ImagePreview } from 'vant';
  import { shareCon } from "@/utils/wxconfig";
  export default {
    data() {
      return {
        //
        userdetail: {},
        tagModul: false,
        body_show: false,
        replyName: "",
        commentShow: true,
        newTagVal: "",
        //
        is_reply_ing: false,
        //
        report: [],  // 海报
        label: [],   // 标签
        reply: [],    // 评价
        //
        uid: "",          // 作业所属人id
        cid: "",          // 课程id
        cpid: "",         // 项目id
        reply_id: "",     // 评论的id,
        reply_uid: "",    // 被回复人的id
        replyContent: "",  // 回复内容
        //
        title: ""
      }
    },
    methods: {
      ofShowContent(index, bool){
        this.reply[index].textOverFlow = bool;
        // this.$set(this.reply[index], 'textOverFlow', bool);
      },
      setPraise(id, index, type, bool){
        PraiseSub({
          id,
          type,
        })
        .then((data) => {
          if(data.code){
            this.$toast.fail('操作失败！');
          }else{
            this.reply[index].praise = bool;
            this.pullData();
          }
        })
      },
      assetsReply(){
        let con = this.replyContent;
        if(!con){
          this.$notify('请输入回复内容！');
          return
        }else if(con.length > 100){
          this.$notify('请输入50个字符以内！');
          return
        }
        return true
      },
      submitHandle(){
        let result = this.assetsReply();
        if(result){
          let json = {
            cid: this.cid,
            cpid: this.cpid,
            uid: this.uid,
            reply: this.replyContent
          }

          if(this['reply_id'] && this['reply_uid']){
            json['reply_id'] = this.reply_id;
            json['return_uid'] = this.reply_uid;
          }
          ReplySub(json)
          .then((data) => {
            if(data.code){
              this.$toast('留言失败！');
            }else{
              this.$toast('留言成功！');
              this.replyContent = "";
              this.pullData();
            }
          })
        }
      },
      toggleReply({ name, id, reply_uid }, bool, isSubmit){

        if(isSubmit) return

        if(bool){
          if(id !== this.reply_id){
            this.replyContent = '';
          }
          // this.commentShow = bool;
          this.replyName = name;
          this.reply_uid = reply_uid;
          this.reply_id = id;
          //
          // 获得焦点
          this.$refs.RC.focus();
        }else{
          // this.commentShow = bool;
          if(!this.replyContent){
            this.replyName = '';
            this.reply_uid = '';
            this.reply_id = '';
          }
        }
      },
      verification(){
        if(this.newTagVal.length > 10){
          this.$notify('请输入10个以内字符');
          return
        }
        if(!this.newTagVal){
          this.$notify('请输入10个以内字符');
          return
        }
        return true
      },
      addTag(){
        let result = this.verification();
        if(!result) return
        // done
        let q = this.$route.query;
        let tv = this.newTagVal;
        let cood = {
          cid: q['cid'],
          cpid: q['cpid'],
          label_title: tv,
        }
        if(q['uid']){
          cood['uid'] = q['uid'];
        }
        LableAdd(cood)
        .then((data) => {
          if(data.code){
            this.$toast.fail('添加失败！');
          }else{
            this.$toast.success('添加成功！');
            this.pullData();
          }
        })
      },
      pullData() {
        let q = this.$route.query;
        let arg = {
          cid: q['cid'],
          cpid: q['cpid']
        }
        if(q['uid']){
          arg['uid'] = q['uid'];
        }
        TaskShow(arg)
        .then((data) => {
          if(data.code){
            this.report = [];
            this.label = [];
          }else{
            this.label = data.label;
            let replyArr = data.reply;
            this.report = data.report;
            this.userdetail = data.userdetail;
            this.uid = data.uid;
            this.cid = data.cid;
            this.cpid = data.cpid;
            this.title = data.report_title;
            //
            for(let key of replyArr){
              key.surplus = true;
              key.textOverFlow = false;
            }
            this.reply = replyArr;
            this.body_show = true;
            //
            this.setMsgOverflow();
          }
        })
      },
      img_preview(num) {
        ImagePreview({
          images: this.report,
          startPosition: num,
          showIndex: false,
          onClose() {
            // do something
          }
        });
      },
      toggleTag({ support, id }, index){
        if(support){
          this.saveTagSatet(id, index, 'cancel', false);
        }else{
          this.saveTagSatet(id, index, 'add', true);
        }
      },
      saveTagSatet(lable_id, index, type, bool){
        LableSub({
          lable_id,
          type
        })
        .then((data) => {
          if(data.code){
            this.$toast.fail('操作失败！');
          }else{
            // 设置是否认可标签
            this.label[index].support = bool;
            this.pullData();
          }
        })
      },
      changeItemClass(ele, index) {
       let styles = window.getComputedStyle(ele, null);
       let lh = parseInt(styles.lineHeight, 10);
       let h = parseInt(styles.height, 10);
       let lc = Math.round(h / lh);

       // 判断高度
       if(lc > 2){
          this.reply[index].surplus = true;
          this.reply[index].textOverFlow = true;
       }else{
          this.reply[index].textOverFlow = false;
          this.reply[index].surplus = false;
       }
      },
      setMsgOverflow(){
        setTimeout(() => {
          let els = document.getElementsByClassName('msg-con');
          let len = els.length;
          for(let i=0; i<len; i++){
            this.changeItemClass(els[i], i);
          }
        }, 100);
      }
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
  }
</script>
<style lang="scss" scoped>
  @import "@s/remChange.scss";
  .report-title{
    font-size: 34px;
    line-height: 120px;
    background: #f0f0f0;
    font-weight: bold;
  }
  .pb50{
    padding: 100px 0;
    font-size: 30px;
  }
  .color-blue{
    color: #0C1D66;
  }
  .text-bold{
    font-weight: bold;
  }
  .text-break{
    word-break:break-all;
  }
  .msg-font{
    font-size: 25px;
    color: #333;
    line-height: 30px;
  }
  .bodys {
    padding-bottom: 55px;
    background-color: #fff
  }
  .pd_auto{
    padding: 30px;
  }
  // 展示图
  .report_main {
    background: #fff;
    text-align: left;
    img.report_img {
      width: 100%;
      height: auto;
      vertical-align: middle;
      margin-top: changeRem(.6)+px;
    }
    h5 {
      color: #333;
      font-size: changeRem(.48)+px;
      padding-right: changeRem(.6)+px;
      margin-top: changeRem(.2)+px;
      text-align: right;
      width: 100%;
    }
  }
  /* 标签 */
  .tag_box{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    color: #EB5032;
    .tag_btn{
      font-size: 29px;
      height: 66px;
      line-height: 66px;
      padding: 0 30px;
      border: 2px solid #EB5032;
      border-radius: 36px;
      display: inline-block;
      margin-bottom: 36px;
      margin-right: 36px;
    }
    .active{
      background: #EB5032;
      color: #fff;
    }
  }
  .add-text{
    margin-top: 21px;
    font-size: 28px;
    color: #ccc;
  }
  .bg-board{
    height: 24px;
    background: #ddd;
  }
  /* 留言 */
  .message{
    padding: 0 36px 80px;
    .msg-item{
      padding-bottom: 14px;
      border-bottom: 2px solid #ccc;
    }
  }
  .no-border{
    border-bottom: none!important;
  }
  .msg-head{
    margin-top: 36px;
    .ico{
      width: 100%;
      margin-right: -614px;
      .ico-img{
        height: 60px;
      }
      img{
        height: 60px;
        border-radius: 30px;
      }
    }
    .msg-user{
      width: 614px;
      height: 60px;
      h4{
        font-size: 25px;
        line-height: 25px;
        font-weight: bold;
        color: #0C1D66;
        margin: 0;
      }
      p{
        margin: 0;
        font-size: 16px;
        color: #999;
      }
      .msg-date{
        bottom: 0;
        left: 0;
      }
    }
    .favor{
      right: 0;
      top: 0;
      *{
        display: inline-block;
        vertical-align: top;
        font-size: 16px;
        color: #999;
      }
      span{
        padding: 0 9px;
      }
      .active{
        color: #EB5032;
      }
      img{
        max-width: 26px;
      }
    }
  }
  .msg-con{
    margin-top: 22px;
    font-size: 26px;
    color: #333;
  }
  .msg-over{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .msg-menu{
    p{
      color: #F57F17;
      line-height: 46px;
    }
    .btn{
      font-size: 26px;
    }
  }
  .child-reply{
    margin-left: 30px;
    .child-item{
      border-bottom: 2px solid #ccc;
      padding: 34px 30px;
      padding-bottom: 20px;
      padding-left: 0;
    }
    .ch-con{
      padding-left: 68px;
      .reply-name{

      }
    }
    .ch-w-ico{
      left: 0;
      top: 0;
      img{
        width: 60px;
        border-radius: 30px;
      }
    }
  }
  .fixed-reply{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    transition: .5s all;
    transform: translate(0px,0px);
    // padding: 16px 100px 16px 30px;
    padding: 16px 100px 16px 30px;
    background: #F0F0F0;
    .no-label{
      .van-field__label{
        display: none;
      }
    }
    .comments{
      width: 100%;
      font-size: 25px;
      padding: 5px 10px;
      border-radius: 5px;
    }
    .save-btn{
      width: 49px;
      right: 30px;
      top: 50%;
      margin-top: -25px;
    }
  }
  .fixed-reply.block{
    transform: translate(0px,0px);
  }
  .fixed-reply.none{
    transform: translate(0px,100%);
  }
  .tag-modul{
    .form-pd{
      padding: 0 20px;
    }
    h3{
      line-height: 120px;
      font-size: 34px;
      border-bottom: 1px solid #ebedf0;
      color: #323233;
    }
    input{
      float: left;
      width: 100%;
      vertical-align: top;
      height: 100px;
      border: none;
    }
  }
</style>
<style>
  .inps .van-field__control{
    font-size: 26px;
    line-height: 40px;
    color: #333;
  }
</style>